import script from "./headline.vue?vue&type=script&setup=true&lang=js"
export * from "./headline.vue?vue&type=script&setup=true&lang=js"

import "./headline.vue?vue&type=style&index=0&id=5cbe2c31&lang=css"

const __exports__ = script;

export default __exports__